import { useSelector } from 'react-redux';

import { IFaqArticleWithState } from '~/src/store/reducers/faq';
import { selectDynamicState } from '~/src/store/selectors/faq';

import { Questions } from './Questions';

interface IQuestionContainerProps {
    title: string,
    statePath: string,
    placeAlias: string,
}

export const QuestionsContainer = ({ title, statePath, placeAlias }: IQuestionContainerProps) => {
    const questions = useSelector(selectDynamicState<IFaqArticleWithState[]>(statePath));

    return <Questions title={title} articles={questions} placeAlias={placeAlias} />;
};
